// TimerContext.tsx
import React, { createContext, useContext, useEffect, useState } from 'react';

interface TimerContextType {
  timestamp: bigint;
  timestampMilliseconds: bigint;
}

const TimerContext = createContext<TimerContextType>({
  timestampMilliseconds: BigInt(Date.now()),
  timestamp: BigInt(Date.now()) / 1000n,
});

export const TimerProvider: React.FC<{
  interval?: number;
  children: React.ReactNode;
}> = ({ interval = 1000, children }) => {
  const [timestampMilliseconds, setTimestampMilliseconds] = useState(
    BigInt(Date.now()),
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setTimestampMilliseconds(BigInt(Date.now()));
    }, interval);

    return () => clearInterval(timer);
  }, [interval]);

  const timestamp = timestampMilliseconds / 1000n;

  return (
    <TimerContext.Provider value={{ timestampMilliseconds, timestamp }}>
      {children}
    </TimerContext.Provider>
  );
};

export const useTimer = () => useContext(TimerContext);
